var exports = {
  "l": "ActionList__jjUxth",
};

module.exports = exports;
